<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>

        <div class="mt-1" v-else>
            <v-row>
                <v-col cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">ประวัติการขายสินค้า</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
            </v-row>

            <div class="mt-1">
                <!-- ===== Controls (Balanced) ===== -->
                <v-card elevation="3" class="pa-4 filter-card">

                    <!-- Row 1: วันที่เริ่ม/สิ้นสุด + สมาชิก (สัดส่วนลงตัวที่ 3-3-3-3) -->
                    <v-row align="end" class="g-compact pr-3 pl-3">
                        <!-- วันที่เริ่ม -->
                        <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <v-text-field v-model="searchDateStart" label="วันที่เริ่มต้น" type="date"
                                class="input-radius" color="#D6BFAF" outlined dense hide-details="auto" />
                        </v-col>

                        <!-- วันที่สิ้นสุด -->
                        <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <v-text-field v-model="searchDateEnd" label="วันที่สิ้นสุด" type="date" class="input-radius"
                                color="#D6BFAF" outlined dense hide-details="auto" />
                        </v-col>

                        <!-- สมาชิก -->
                        <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <v-autocomplete v-model="memberId" :items="memberOptions" :loading="loadingMembers"
                                item-text="name" item-value="id" label="สมาชิก" class="input-radius" color="#D6BFAF"
                                outlined dense clearable hide-details="auto" :filter="memberFilter" />
                        </v-col>

                        <!-- ปุ่มค้นหา -->
                        <v-col cols="12" sm="6" md="3" lg="3" xl="3" class="text-right">
                            <v-btn block color="#8cc63e" class="white--text input-radius" :loading="loading_btn"
                                :disabled="!searchDateStart || !searchDateEnd" @click="searchByDate">
                                <v-icon left>mdi-magnify</v-icon>
                                ค้นหาประวัติ
                            </v-btn>
                        </v-col>
                    </v-row>



                    <!-- Row 2: เลือกสินค้า (เต็มความกว้าง เพื่อสมดุลสายตา) -->
                    <v-row class="pr-3 pl-3 mt-2 align-end">
                        <!-- ซ้าย: เลือกสินค้า (คงโครงสร้างเดิมทั้งหมด) -->
                        <v-col cols="12" md="8" lg="8" xl="8">
                            <v-autocomplete prepend-icon="mdi-package-variant" ref="productAuto"
                                v-model="selectedProducts" :items="productOptions" :loading="loadingProducts"
                                label="ค้นหา/เลือกสินค้า (หลายรายการได้)" multiple clearable return-object
                                item-text="label" item-value="value.id" hide-details="auto" outlined dense
                                class="input-radius" cache-items :search-input.sync="productSearch"
                                @focus="prefetchOnce"
                                :menu-props="{ contentClass: 'product-select-menu', offsetY: true, maxHeight: 320 }"
                                no-data-text="ไม่พบสินค้า">
                                <!-- ===== selections (แสดง chip และสรุปรายการที่เลือก) ===== -->
                                <!-- selections -->
                                <template v-slot:selection="{ item }">
                                    <!-- โชว์ 3 ตัวแรก -->
                                    <v-chip small class="ma-2">
                                        {{ item.label }}
                                    </v-chip>

                                    <!-- ชิ้นสรุปเป็นชิป +N (ใช้ v-menu แต่ต้องใช้ activator slot) -->
                                    <!-- <template v-else-if="selectedProducts.length > 3 && index === 3">
                                        <v-menu open-on-hover offset-y :close-on-content-click="false"
                                            content-class="more-chip-menu" transition="fade-transition">
                                            
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-chip small class="ma-2" color="grey lighten-3" text-color="black"
                                                    v-on="on" v-bind="attrs">
                                                    +{{ selectedProducts.length - 3 }} รายการ
                                                </v-chip>
                                            </template>

                    <div class="pa-2 menu-scroller">
                        <div v-for="p in selectedProducts.slice(3)" :key="p.value.id" class="caption"
                            style="line-height:1.2;">
                            • {{ p.label }}
                            <span class="grey--text">({{ p.value.product_code }})</span>
                        </div>
                    </div>
                    </v-menu>
                    </template> -->
                                </template>


                                <!-- ===== item (มีเช็คบ็อกซ์ + แถว 'สินค้าทั้งหมด') ===== -->
                                <template v-slot:item="{ item, on, attrs }">
                                    <v-list-item v-if="item?.value?.id === 'ALL'" v-bind="attrs" class="product-item"
                                        @mousedown.prevent @click.stop="selectedProducts = [item]">
                                        <v-list-item-action>
                                            <v-checkbox :input-value="isAllSelected"
                                                @change.stop="selectAllProducts(item)" color="#8cc63e" hide-details />
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title><strong>สินค้าทั้งหมด</strong></v-list-item-title>
                                            <v-list-item-subtitle class="grey--text">
                                                เลือกเฉพาะรายการนี้ และล้างตัวเลือกอื่นทั้งหมด
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item v-else v-bind="attrs" :key="item.value.id" class="product-item"
                                        @mousedown.prevent @click.stop="toggleSelection(item)"
                                        v-on="{ ...on, click: () => { } }">
                                        <v-list-item-action>
                                            <v-checkbox :input-value="isSelected(item)"
                                                @change.stop="toggleSelection(item)" color="#8cc63e" hide-details />
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.label }}</v-list-item-title>
                                            <v-list-item-subtitle class="grey--text">
                                                code: {{ item.value.product_code }} | id: {{ item.value.id }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>

                                <!-- ===== append ด้านล่างลิสต์ ===== -->
                                <template v-slot:append-item>
                                    <v-divider class="mb-2" />
                                    <div class="px-3 pb-3">
                                        <v-btn block small class="mb-2" :loading="loadingMore"
                                            :disabled="!hasMore || loadingMore" @click.stop.prevent="loadMore()">
                                            {{ hasMore ? 'โหลดเพิ่มเติม' : '— สิ้นสุดรายการ —' }}
                                        </v-btn>
                                        <v-btn block small color="#8cc63e" class="white--text"
                                            @click.stop.prevent="confirmProductSelection">
                                            ตกลง
                                        </v-btn>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <!-- ขวา: เลือกสาขา (หน้า-ตาเดียวกับอินพุตอื่น ๆ) -->
                        <v-col cols="12" md="4" lg="4" xl="4">
                            <v-select v-model="selectedBranch" :items="branches" item-text="name" item-value="id"
                                label="เลือกสาขา" prepend-icon="mdi-store" color="#D6BFAF" outlined dense clearable
                                hide-details="auto" class="input-radius" @change="fetchSalesHistory" />
                        </v-col>
                    </v-row>




                    <!-- Row 3: ช่องค้นหา (ย้ายลงมาข้างล่าง ใต้เลือกสินค้า) -->
                    <v-row class="pr-3 pl-3 mt-1" align="center">
                        <v-col>
                            <v-text-field v-model="search" placeholder="ค้นหา..." append-icon="mdi-magnify" outlined
                                dense class="input-radius" color="#D6BFAF" hide-details="auto" />
                        </v-col>
                    </v-row>


                    <!-- ตารางข้อมูลของคุณคงเดิมต่อจากนี้ -->
                    <section class="pa-3 mt-2 table-wrap">
                        <v-data-table :headers="headers" :items="data_list" :search="search"
                            :footer-props="footer_Props" mobile-breakpoint="0" dense class="elevation-1 sales-table">
                            <template v-slot:item="dataDetail">
                                <tr>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.doc_date }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.product_name }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.member_name || '-' }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.unit_name }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.doc_no }}</div>
                                    </td>
                                    <td class="text-right">
                                        <div class="font-16">{{ formatQty(dataDetail.item.qty) }}</div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </section>
                </v-card>


            </div>
        </div>
    </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";

export default {
    inject: { theme: { default: { isDark: false } } },
    name: "Sales_History_Report",
    data() {
        return {
            loading_page: false,
            loading_btn: false,
            search: "",
            searchDateStart: "",
            searchDateEnd: "",
            footer_Props: { "items-per-page-text": "รายการต่อหน้า" },
            headers: [
                { text: "วันที่เอกสาร", value: "doc_date", fixed: true, width: "140px" },
                { text: "ชื่อสินค้า", value: "product_name", fixed: true, width: "260px" },
                { text: "ชื่อสมาชิก", value: "member_name", fixed: true, width: "220px" },
                { text: "หน่วยนับ", value: "unit_name", fixed: true, width: "120px" },
                { text: "เลขที่เอกสาร", value: "doc_no", fixed: true, width: "160px" },
                { text: "จำนวน", value: "qty", fixed: true, width: "120px", align: "end" },
            ],
            data_list: [],
            sub_menu: [
                { text: "ระบบขาย", disabled: false },
                { text: "รายงาน", disabled: false },
                { text: "ประวัติการขายสินค้า", disabled: false },
            ],

            // ตัวกรอง/ออพชัน
            selectedProducts: [],
            productOptions: [],
            loadingProducts: false,
            loadingMore: false,
            productSearch: "",
            searchTimer: null,
            nextCursor: null,
            hasMore: true,

            memberId: null,
            memberOptions: [],
            loadingMembers: false,

            branches: [],
            selectedBranch: null,
        };
    },

    computed: {
        isAllSelected() {
            return this.selectedProducts.some(p => p?.value?.id === "ALL");
        },
        // ใช้ค่า store ที่ล็อกอินเป็น fallback
        loginStoreId() {
            return (
                this.$store?.state?.store_arin?.user_data?.store_id ??
                this.$store?.state?.store_arin?.store_id ??
                this.$store?.state?.store_arin?.store?.id ??
                null
            );
        },
        // id สาขาที่จะใช้จริง (ขวา>ซ้าย: สาขาที่เลือก || สาขาล็อกอิน)
        effectiveStoreId() {
            return this.selectedBranch && this.selectedBranch !== "ALL"
                ? this.selectedBranch
                : this.loginStoreId;
        },
        // product_ids สำหรับส่งให้หลังบ้าน (ถ้าเลือก ALL จะไม่ส่ง)
        selectedProductIds() {
            if (this.isAllSelected) return undefined;
            const ids = this.selectedProducts
                .map(p => p?.value?.id)
                .filter(Boolean);
            return ids.length ? ids : undefined;
        },
        // member_id สำหรับส่ง (ถ้า ALL จะไม่ส่ง)
        effectiveMemberId() {
            return this.memberId && this.memberId !== "ALL" ? this.memberId : undefined;
        },
    },

    methods: {
        formatQty(v) {
            if (v == null || v === "") return "-";
            const num = Number(v);
            return isNaN(num) ? v : num.toLocaleString(undefined, { maximumFractionDigits: 2 });
        },

        mapResponse(rows = []) {
            return rows.map(r => ({
                doc_date: r.doc_date,
                product_name: r.product_name,
                member_name: r.member_name,
                unit_name: r.unit_name,
                doc_no: r.doc_no,
                qty: r.qty,
            }));
        },

        // ✅ ดึงประวัติ โดยยึดค่าที่ล็อกอิน/สาขาที่เลือก
        async fetchSalesHistory(extraParams = {}) {
            // ⛔ ยังไม่เลือกวันครบ ไม่ต้องยิง API
            if (!this.searchDateStart || !this.searchDateEnd) return;

            this.loading_page = true;
            try {
                const params = {
                    dateStart: this.searchDateStart,
                    dateEnd: this.searchDateEnd,
                    store_id: this.effectiveStoreId || undefined,
                    member_id: this.effectiveMemberId,
                    product_ids: this.selectedProductIds,
                    ...extraParams,
                };

                const res = await HTTP_ARIN.get("/pos/report/sales/history", {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
                    },
                    params,
                });

                this.data_list = res?.data?.successful ? this.mapResponse(res.data.data || []) : [];
            } catch (e) {
                console.error("fetchSalesHistory error:", e);
                this.data_list = [];
            } finally {
                this.loading_page = false;
                this.loading_btn = false;
            }
        },


        async loadCustomers() {
            try {
                this.loadingMembers = true;
                const res = await HTTP_ARIN.get('/pos/history/get/customer', {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
                    },
                });

                if (res?.data?.successful) {
                    const rows = Array.isArray(res.data.data) ? res.data.data : [];
                    // backend คืน: { id, member_name, tel_number }
                    const mapped = rows.map(r => ({
                        id: r.id,
                        name: r.member_name || '-',       // ✅ ให้ item-text ใช้ 'name' เหมือนเดิม
                        tel_number: r.tel_number || '',   // ✅ เก็บไว้ใช้ค้นหาเบอร์
                    }));

                    this.memberOptions = [{ id: 'ALL', name: 'สมาชิกทั้งหมด', tel_number: '' }, ...mapped];
                } else {
                    this.memberOptions = [{ id: 'ALL', name: 'สมาชิกทั้งหมด', tel_number: '' }];
                }
            } catch (e) {
                console.error('loadCustomers error:', e);
                this.memberOptions = [{ id: 'ALL', name: 'สมาชิกทั้งหมด', tel_number: '' }];
            } finally {
                this.loadingMembers = false;
            }
        },
        memberFilter(item, query) {
            const q = String(query || '').toLowerCase().trim();
            if (!q) return true;

            const name = String(item?.name || '').toLowerCase();
            const phone = String(item?.tel_number || '');
            // ตัดอักขระที่ไม่ใช่ตัวเลขเพื่อค้นหาเบอร์แบบ 08-xxx ก็เจอ
            const phoneDigits = phone.replace(/\D/g, '');
            const qDigits = q.replace(/\D/g, '');

            // ตรงชื่อ หรือ ตรงเลขเบอร์ (บางส่วนก็ได้)
            return name.includes(q) || (!!qDigits && phoneDigits.includes(qDigits));
        },



        async loadBranches() {
            try {
                const res = await HTTP_ARIN.get("/pos/history/get/store", {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
                    },
                });
                const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
                const mapped = rows.map(b => ({ id: b.id, name: b.store_name || `สาขา ${b.id}` }));
                this.branches = [{ id: "ALL", name: "ทุกสาขา" }, ...mapped];

                // ดีฟอลต์เป็นสาขาที่ล็อกอิน ถ้ามีในลิสต์ ไม่งั้น ALL
                const found = mapped.find(b => String(b.id) === String(this.loginStoreId));
                this.selectedBranch = found ? found.id : "ALL";
            } catch (e) {
                console.error("loadBranches failed:", e);
                this.branches = [{ id: "ALL", name: "ทุกสาขา" }];
                this.selectedBranch = "ALL";
            }
        },

        // ปุ่ม “ตกลง” ในเมนูสินค้า — ปิดเมนูเฉย ๆ
        confirmProductSelection() {
            const auto = this.$refs.productAuto;
            if (!auto) return;

            // ปิดเมนู
            if (typeof auto.isMenuActive !== "undefined") auto.isMenuActive = false;
            this.$nextTick(() => {
                if (auto.$refs?.menu && typeof auto.$refs.menu.isActive !== "undefined") {
                    auto.$refs.menu.isActive = false;
                }
                auto.blur && auto.blur();
            });

            // 🔍 ยิงค้นหาเมื่อเลือกวันครบแล้วเท่านั้น
            // if (this.searchDateStart && this.searchDateEnd) {
            //     this.fetchSalesHistory();
            // }
        },


        prefetchOnce() {
            if (!this.productOptions.length && !this.loadingProducts) {
                this.loadProducts({ limit: 50 });
            }
        },
        selectAllProducts(item) {
            this.selectedProducts = [item];
        },
        isSelected(item) {
            const id = item?.value?.id;
            return this.selectedProducts.some(p => p?.value?.id === id);
        },
        toggleSelection(item) {
            if (item?.value?.id === "ALL") {
                this.selectedProducts = [item];
                return;
            }
            if (this.selectedProducts.some(p => p?.value?.id === "ALL")) {
                this.selectedProducts = this.selectedProducts.filter(p => p?.value?.id !== "ALL");
            }
            const id = item?.value?.id;
            const idx = this.selectedProducts.findIndex(p => p?.value?.id === id);
            if (idx === -1) this.selectedProducts = [...this.selectedProducts, item];
            else {
                const next = [...this.selectedProducts];
                next.splice(idx, 1);
                this.selectedProducts = next;
            }
        },

        // ✅ โหลดสินค้าตามสาขาที่ใช้งานจริง (ถ้าหลังบ้านรองรับการกรอง)
        async loadProducts(params = { limit: 50 }) {
            try {
                this.loadingProducts = true;
                const res = await HTTP_ARIN.get("/pos/history/get/product", {
                    params: {
                        ...params,
                        store_id: this.effectiveStoreId || undefined, // ส่งไปด้วยถ้ากรองได้
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
                    },
                });

                const data = res?.data;
                const list = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
                const mapped = list.map(it => ({
                    label: it.product_name || it.name || it.product_code || `ID ${it.id}`,
                    value: { id: it.id, product_code: it.product_code },
                }));

                const seen = new Set(this.productOptions.map(i => i.value.id));
                this.productOptions = this.productOptions.concat(mapped.filter(i => !seen.has(i.value.id)));

                // ใส่ "สินค้าทั้งหมด" ไว้บนสุดครั้งเดียว
                const allOption = { label: "สินค้าทั้งหมด", value: { id: "ALL", product_code: "*" } };
                if (!this.productOptions.some(o => o?.value?.id === "ALL")) {
                    this.productOptions.unshift(allOption);
                }

                this.nextCursor = data?.next_cursor || null;
                this.hasMore = !!data?.has_more;
            } catch (e) {
                console.error("loadProducts error:", e);
                this.$toast?.error?.("โหลดรายการสินค้าไม่สำเร็จ");
            } finally {
                this.loadingProducts = false;
            }
        },

        async loadMore() {
            if (!this.hasMore || !this.nextCursor) return;
            try {
                this.loadingMore = true;
                const q = (this.productSearch || "").trim();
                const params = { limit: 50, cursor: this.nextCursor };
                if (q.length >= 2) params.q = q;

                const res = await HTTP_ARIN.get("/pos/history/get/product", {
                    params: {
                        ...params,
                        store_id: this.effectiveStoreId || undefined,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
                    },
                });

                const data = res?.data;
                const list = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
                const mapped = list.map(it => ({
                    label: it.product_name || it.name || it.product_code || `ID ${it.id}`,
                    value: { id: it.id, product_code: it.product_code },
                }));

                const seen = new Set(this.productOptions.map(i => i.value.id));
                this.productOptions = this.productOptions.concat(mapped.filter(i => !seen.has(i.value.id)));

                this.nextCursor = data?.next_cursor || null;
                this.hasMore = !!data?.has_more;
            } catch (e) {
                console.error("loadMore error:", e);
                this.$toast?.error?.("โหลดรายการสินค้าเพิ่มไม่สำเร็จ");
            } finally {
                this.loadingMore = false;
            }
        },

        async searchByDate() {
            this.loading_btn = true;
            await this.fetchSalesHistory(); // ใช้พารามิเตอร์จาก state แล้ว
        },
    },

    watch: {
        //searchDateStart(val) {
        //    if (val && this.searchDateEnd) this.searchByDate();
        //},
        //searchDateEnd(val) {
        //    if (val && this.searchDateStart) this.searchByDate();
        //},
        selectedBranch() {
            // เปลี่ยนสาขาแล้ว โหลดรายการสินค้าใหม่ได้
            this.productOptions = [];
            this.nextCursor = null;
            this.hasMore = true;
            this.loadProducts({ limit: 50 });

            // ยิงค้นหาเฉพาะเมื่อเลือกวันครบ
            if (this.searchDateStart && this.searchDateEnd) {
                this.fetchSalesHistory();
            }
        },
        memberId() {
            if (this.searchDateStart && this.searchDateEnd) {
                this.fetchSalesHistory();
            }
        },

        // 👉 ตัด watcher นี้ทิ้ง (ไม่ยิงค้นหาอัตโนมัติ)
        // selectedProducts: {
        //   deep: true,
        //   handler() { this.fetchSalesHistory(); },
        // },

        // การค้นหาชื่อสินค้าในช่อง (ยังโหลดรายการสินค้าได้ตามเดิม)
        productSearch(val) {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(async () => {
                const q = (val || "").trim();
                this.productOptions = [];
                this.nextCursor = null;
                this.hasMore = true;
                if (q.length < 2) await this.loadProducts({ limit: 50 });
                else await this.loadProducts({ q, limit: 50 });
            }, 300);
        },
    }
    ,

    mounted() {
        // โหลดรายการสาขา/ลูกค้าไว้ก่อน (ไม่ยิงตาราง)
        this.loadBranches().then(() => {
            // ไม่ fetchSalesHistory ที่นี่
            this.loadProducts({ limit: 50 }); // ให้ค้นหาสินค้าได้เลยเมื่อต้องการ
        });
        this.loadCustomers();
    }
    ,
};
</script>


<style scoped>
/* ให้ฟอนต์ในคอลัมน์เหมือนหน้าตัวอย่าง */
.font-16 {
    font-size: 16px;
}

/* ให้จำนวนชิดขวา */
:deep(.v-data-table td.text-right) {
    text-align: right !important;
}

/* ปรับ radius ปุ่ม/ช่องกรอกให้คล้ายตัวอย่าง */

/* ลดช่องไฟ v-row ให้แน่นขึ้นแต่ยังอ่านง่าย */
.g-compact>.col,
.g-compact>[class*="col-"] {
    padding-top: 8px;
    padding-bottom: 8px;
}

/* โค้งมน input */
.input-radius {
    border-radius: 10px;
}

/* ให้เมนูของ v-autocomplete กว้างเท่าตัว input */
.product-select-menu {
    min-width: 100% !important;
}

/* กันตารางล้นเวลาแคบ */
.table-wrap {
    overflow-x: auto;
}

:deep(.v-select__selections) {
    flex-wrap: wrap;
}

.menu-scroller {
    background: #414141;
    /* ดำทึบ ไม่โปร่งใส */
    color: #fff;
    max-width: 280px;
    max-height: 200px;
    overflow: auto;
    text-align: left;
    padding: 8px 10px;
    margin-top: 1%;
    /* ย้าย padding มาที่นี่ */
}
</style>
